<template>
  <FormSubmitPopup
    :title="$t('exportClientsRechargeTransaction')"
    :value="show"
    :rightMethod="exportClientsRechargeTransaction"
    :disabledClose="loading"
    :leftMethod="() => show = false"
    :rightButtonText="$t('export')"
    :rightButtonDisabled="!selectedClients.length"
    small
  >
    <template v-slot:input>
      <v-container py-0 fluid>
        <v-layout>
          <v-flex xs4>
            <DatePicker
              :label="$t('month')"
              v-model="month"
              mode="month"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-combobox
              :label="$t('organizations')"
              :items="clients"
              v-model="selectedClients"
              chipText="clientName"
              itemText="clientName"
              :counter="10"
              chips
              multiple
              clearable 
              return-object
            />
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </FormSubmitPopup>
</template>

<script>
import DatePicker from './DatePicker'
import FormSubmitPopup from './FormSubmitPopup'
import { exportListToXlsx } from '@/utils/tools'

export default {
  name: 'ExportClientsRechargeTransactionPopup',
  components: {
    FormSubmitPopup,
    DatePicker
  },
  props: {
    value: {
      required: true,
      type: Boolean
    },
    clients: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      selectedClients: [],
      month: new Date()
    }
  },
  computed: {
    show: {
      get: function () {
        return this.value
      },
      set: function (val) {
        this.$emit('input', val)
        if (!val) {
          this.selectedClients = []
          this.month = new Date()
        }
      }
    }
  },
  methods: {
    async exportClientsRechargeTransaction () {
      try {
        this.loading = true
        const data = await this.$store.dispatch('exportClientsRechargeTransaction', {
          date: this.month,
          clients: this.selectedClients.filter(item => item?.clientKey)
        })
        const clientMap = data.reduce((res, item) => {
          const { clientKey } = item
          if (res[clientKey]) {
            res[clientKey].push(item)
          } else {
            res[clientKey] = [item]
          }
          return res
        }, {})
        exportListToXlsx(
          [
            [
              this.$t('date'),
              this.$t('description'),
              this.$t('amount'),
              this.$t('note')
            ],
            ...Object.values(clientMap).reduce((res, items) => {
              res.push([], [items[0].clientName])
              items.forEach(item => {
                res.push([
                  item.createTime, 
                  item.type || '',
                  String(item.amount || 0),
                  item.note || ''
                ])
              })
              return res
            }, [])
          ], `${this.month.getFullYear()}-${this.month.getMonth() + 1}-exportClientsRechargeTransaction.csv`
        )
        this.loading = false
        this.show = false
      } catch (err) {
        console.log(err)
        alert(err.message)
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/exportClientsRechargeTransactionPopup.vue